import NProgress from 'nprogress'
import {computed, ref} from "vue";

export const router_prefetch = ref(false);
export const router_progress = computed(() => {
    return router_progress_percent.value !== 100 && router_progress_percent.value !== 0;
});
export const router_progress_percent = ref(0);
